import { useEffect, useState } from 'react';

import { Avatar, Button, Drawer, DrawerProps } from 'antd';
import styled from 'styled-components';

import { getRoomUserList, getProfileDownloadURL, shareFile } from '../../../_actions/CampusNoteAction'

import LANG from './i18n';

import { DrawerCloseIco, NoneThumbnail } from './SvgIco';
import CODE from 'constants/code';
import { InappModalInfo } from './FileManageCommon';

interface UserListType {
  uid: number;
  status: number;
  userName: string;
  thumbnail?: string;
}

interface ShareUserListProps extends DrawerProps {
  userLang: string;
  roomId: Number;
  fileObj: any;
  userList: UserListType[];
  setShowShareUserList:any;
}

export const ShareUserList = (props: ShareUserListProps) => {
  const { userLang, roomId, fileObj, userList, onClose, open, setShowShareUserList } = props;

  const [checkUserList, setCheckUserList] = useState<number[]>([]);

  // const [userList, setUserList] = useState<UserListType[]>([]);

  const handleCheckUser = (userId: number) => {
    setCheckUserList((prev) =>
      prev.includes(userId) ? prev.filter((id) => id !== userId) : [...prev, userId]
    );
  };

  const handleShareFile = () => {
    shareFile(fileObj.uid, checkUserList, roomId)
    .then((response) => {
      if (Number(response.data.resultCode) === Number(CODE.RCV_SUCCESS)) {
        let json: any = response.data;
        if(json.userList != null){
          var name = response.data.userList.join('\n') + '\n';
          InappModalInfo(
              name +
              LANG[`${userLang}`]['t'][
                '위_참여자가_노트_사용량을_초과하여_공유할_수_없습니다.'
              ],
            userLang,
            false
          );
        }else{
          InappModalInfo(LANG[`${userLang}`]['t']['노트를_공유했습니다'], userLang);
        }
      } 
      else {
        InappModalInfo(LANG[`${userLang}`]['t'][response.data.resultMessage], userLang);
      }
      setShowShareUserList(!open)
    })
    .catch((err) => {
      if (!err.response) {
        InappModalInfo(LANG[`${userLang}`]['t']['서버와의_통신_오류가_발생했습니다.']);
      } else {
        InappModalInfo(
          err.response.resultMessage || LANG[`${userLang}`]['t']['잠시_후_시도해주세요.'],
          userLang
        );
      }
    });
  };

  useEffect(() => {
    if (!open) {
      setCheckUserList([]);
    }
    // getRoomUserList(roomId, uid)
    // .then((response) => {
    //   if (Number(response.data.resultCode) === Number(CODE.RCV_SUCCESS)) {
    //     let json: UserListType[] = response.data.userList;
    //     setUserList(json);
    //   } else {
    //     InappModalInfo(response.data.resultMessage, userLang);
    //   }
    // })
    // .catch((err) => {
    //   // if (!err.response) {
    //   //   InappModalInfo(LANG[`${userLang}`]['t']['서버와의_통신_오류가_발생했습니다.']);
    //   // } else {
    //   //   InappModalInfo(
    //   //     err.response.resultMessage || LANG[`${userLang}`]['t']['잠시_후_시도해주세요.'],
    //   //     userLang
    //   //   );
    //   // }
    //   console.log("Failed to get userList");
    // });

  }, [open]);

  return (
    <StyledDrawer
      onClose={onClose}
      open={open}
      width={364}
      maskClosable={false}
      closable={false}
      mask={false}
    >
      <div className="drawer-content">
        <div style={{ width: '100%', height: '100%' }}>
          <div className="drawer-header">
            <DrawerCloseIco onClick={onClose} />
          </div>
          <div className="user-list share-group-list">
            <div>
              {userList?.map((user) => {
                const isChecked = checkUserList.includes(user.uid);
                return (
                  <div
                    key={user.uid}
                    onClick={() => handleCheckUser(user.uid)}
                    className={isChecked ? 'checked' : ''}
                  >
                    <div className="thumbnail">
                      {user.thumbnail ? (
                        <Avatar
                          size={32}
                          src={getProfileDownloadURL(user.thumbnail)}
                          style={{
                            backgroundColor: '#fff',
                          }}
                        />
                      ) : (
                        <NoneThumbnail />
                      )}

                      <div className={`online ${user.status == 1 ? 'on' : ''}`}></div>
                    </div>
                    <p>{user.userName}</p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        <div className="drawer-bottom">
          <Button
            style={{ width: '154px', height: '46px', borderRadius: '30px', fontSize: '16px' }}
            type="primary"
            onClick={() => handleShareFile()}
            className={'footerBtn2'}
          >
            {LANG[`${userLang}`]['t']['완료']}
          </Button>
        </div>
      </div>
    </StyledDrawer>
  );
};

const StyledDrawer = styled(Drawer)`
  svg {
    display: block;
  }

  .drawerCloseIco {
    float: right;
    cursor: pointer;
    margin-bottom: 30px;
  }

  .ant-drawer-body {
    padding: 20px 30px 76px;
  }

  .drawer-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    justify-content: space-between;
  }

  .drawer-header {
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }

  .user-list {
    height: calc(100% - 100px);

    display: flex;
    flex-direction: column;
    gap: 8px;
    overflow-x: hidden;
    overflow-y: auto;

    > div {
      display: flex;
      flex-direction: column;
      gap: 8px;
      align-items: center;
      width: 100%;

      > div {
        cursor: pointer;
        padding: 8px 16px;
        display: flex;
        align-items: center;
        border-radius: 10px;
        background: rgba(143, 143, 143, 0.2);
        width: 304px;
        height: 48px;
        font-size: 16px;
        font-weight: 600;
        gap: 16px;

        p {
          margin: 0;
        }
      }

      > div.checked {
        background: #e5f6ff;
        border: 1px solid #00a9ff;
        padding: 8px 15px;
      }

      .thumbnail {
        position: relative;
      }

      .ant-avatar-image {
        border: 1px solid #c2c2c2;
      }

      .online {
        border: 1px solid #fff;
        width: 10.67px;
        height: 10.67px;
        border-radius: 50%;
        background: #8f8f8f;
        position: absolute;
        right: 0;
        bottom: 0;
      }

      .online.on {
        background: #52c41a;
      }
    }
  }
`;
